import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const SortIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "sort",
  "SortIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M8.00033 2L10.667 6L5.33366 6L8.00033 2Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M8.00033 14L10.667 10L5.33366 10L8.00033 14Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M7.33317 10L7.33317 6L8.6665 6L8.6665 10L7.33317 10Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default SortIcon;
